import WKT from "ol/format/WKT";
import * as project from "@/api/project.js";
import { commonFunctions } from "@/utils/index";

export default {
  state: {
    project: {},
    task: {},

    overlayHiddenItem: {
      aptInfo: ["infoName", "label1", "label2", "label3"],
      offInfo: ["infoName", "label1", "label2", "label3"],
    }, //숨김필터 (임시)
    filter: {}, //url filter : filter[id]='&&filter1=1&&filter2=2'...
    hide: {}, //hide[id] = [feature_id, feature_id2, feature_id3...]
    show: {}, //show[id] = [feature_id, feature_id2, feature_id3...]

    viewHiddenFeatures: {}, //숨김처리된 피쳐 보이기 viewHiddenFeatures[id] = true/false,

    selectedProject: 0,
  },
  getters: {
    getProject: (state) => state.project,
    getTask: (state) => state.task,

    getOverlayHiddenItem: (state) => state.overlayHiddenItem,
    getFilter: (state) => state.filter,
    getFilterURL(state) {
      // Getter with parameter.
      return function (id) {
        if (state.filter[id]) {
          return encodeURIComponent(JSON.stringify(state.filter[id]));
        } else {
          return "";
        }
      };
    },
    getHide: (state) => state.hide,
    getShow: (state) => state.show,

    getViewHiddenFeatures: (state) => state.viewHiddenFeatures,

    getSelectedProject: (state) => state.selectedProject || 0,
  },
  mutations: {
    SET_PROJECT(state, payload) {
      state.project = payload;
    },
    SET_TASK(state, payload) {
      state.task = payload;
      // Task 지정시 Release 설정 제거
      this.commit("SET_RELEASE", {});
    },
    SET_OVERLAY_HIDDEN_ITEM(state, payload) {
      state.overlayHiddenItem[payload.name] = payload.value;
    },
    SET_FILTER(state, payload) {
      //state.filter[payload.id] = payload.filter;
      this._vm.$set(state.filter, payload.id, payload.filter);
    },
    CLEAR_FILTER(state) {
      state.filter = {};
    },
    SET_HIDE(state, payload) {
      this._vm.$delete(state.hide, payload.id);
      this._vm.$set(state.hide, payload.id, payload.features);
      //state.hide[payload.id] = payload.features;
    },
    SET_SHOW(state, payload) {
      state.show[payload.id] = payload.show;
    },
    CLEAR_HIDE(state) {
      state.hide = {};
    },
    CLEAR_SHOW(state) {
      state.show = {};
    },
    SET_VIEW_HIDDEN_FEATURES(state, payload) {
      this._vm.$set(state.viewHiddenFeatures, payload.id, payload.view);
    },

    SET_SELECTED_PROJECT(state, payload) {
      state.selectedProject = payload;
    },
  },
  actions: {
    setLayerByTask(context, payload) {
      const task = payload;
      const itemMasterList = context.getters.getItemMasterList;
      context.commit("CLEAR_ACTIVE_LAYERS");
      context.commit("CLEAR_FILTER");
      context.commit("CLEAR_HIDE");
      context.commit("CLEAR_SHOW");

      let usedKey = [];

      task.task_item.forEach((e) => {
        var itemmaster = itemMasterList.find((i) => i.id == e.item);
        let item_url = "";
        if (e.item_url) {
          try {
            item_url = JSON.parse(e.item_url);
          } catch {
            item_url = e.item_url;
          }
        }

        var filter = {
          id: e.item,
          filter: item_url,
        };

        if (!usedKey.includes(e.item)) {
          context.commit("SET_FILTER", filter);
          if (item_url) {
            usedKey.push(e.item);
          }
        }

        if (e.hide.length > 0) {
          context.dispatch("addHideByTask", { id: e.item, hide: e.hide });
        }
        // e.hide.forEach((i) => {
        //   console.log(i.feature_id);
        //   var map = { id: e.item, featureId: i.feature_id.toString() };
        //   console.log(map);
        //   //context.dispatch("addHide", map);
        // });

        let show = [];
        e.show.forEach((i) => {
          show.push(i.feature_id.toString());
        });
        context.commit("SET_SHOW", { id: e.item, show: show });

        // is_show가 true인 것만 activelayers에 추가
        if (e.is_show) {
          context.dispatch("addActiveLayers", itemmaster);
          const checkList = context.getters.getItemDuplList;
          if (checkList.includes(itemmaster.source_type)) {
            var data = {
              id: itemmaster.id,
              source_type: itemmaster.source_type,
            };
            context.dispatch("setItemType", data);
          }
        }
      });

      if (task.zoom_level) context.commit("SET_ZOOM", task.zoom_level);

      if (task.location_wkt) {
        try {
          var format = new WKT();
          const location_wkt = format.readFeature(task.location_wkt, {
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:4326",
          });
          context.commit(
            "SET_CENTER",
            location_wkt.getGeometry().flatCoordinates
          );
          context.commit("SET_IS_CENTER_UPDATE", true);
        } catch (e) {
          console.log(e);
        }
      }

      //작업탭으로 바꾸기
      context.commit("SET_ACTIVE_TAB", "작업");
    },
    addHide(context, payload) {
      var hidelist = context.getters.getHide;
      if (hidelist[payload.id]) {
        if (!hidelist[payload.id].includes(payload.featureId)) {
          hidelist[payload.id].push(payload.featureId);

          context.commit("SET_HIDE", {
            id: payload.id,
            features: hidelist[payload.id],
          });
        }
      } else {
        hidelist[payload.id] = [payload.featureId];

        context.commit("SET_HIDE", {
          id: payload.id,
          features: hidelist[payload.id],
        });
      }
    },
    addHideByTask(context, payload) {
      let hidelist = payload.hide.map((x) => x.feature_id.toString());
      context.commit("SET_HIDE", {
        id: payload.id,
        features: hidelist,
      });
    },
    delHide(context, payload) {
      var hidelist = context.getters.getHide;
      var newList = [];
      if (hidelist[payload.id].length == 1) {
        newList = [];
      } else {
        newList = hidelist[payload.id].filter(
          (element) => element != payload.featureId
        );
      }
      context.commit("SET_HIDE", { id: payload.id, features: newList });
    },

    addShow({ commit }, payload) {
      project.postTaskShow(this.getters.getTask.id, payload).then(() => {
        let show = this.getters.getShow[payload.id] || [];
        show.push(payload.featureId);
        commit("SET_SHOW", { id: payload.id, show: show });
        commit("SET_IS_REFRESG_LAYER", "8ca73eb1-a282-42a8-8fcb-7569239562a6"); // Reset Layer
      });
    },
    delShow({ commit }, payload) {
      project.delTaskShow(this.getters.getTask.id, payload).then(() => {
        let show = this.getters.getShow[payload.id] || [];
        commonFunctions.popByData(show, payload.featureId);
        commit("SET_SHOW", { id: payload.id, show: show });
        commit("SET_IS_REFRESG_LAYER", "8ca73eb1-a282-42a8-8fcb-7569239562a6"); // Reset Layer
      });
    },
  },
};
